var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"vuw-color-switch vuw-background-switch"},_vm._l((_vm.subtopics),function(item){return _c('portal-subtopic-component',{key:item.title,attrs:{"item":item}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }